import conversationRoutes from "conversations/routes";

export default conversationRoutes;
